import React from 'react';
import { createRoot } from 'react-dom/client';
import * as LucideIcons from 'lucide-react';
import { Eye as faEye } from 'lucide-react';
import { fontAwesomeToLucideMap } from './lucide-mapping';

export const getLucideIconByName = (iconName: string): React.ComponentType<any> => {
  if (!iconName) {
    return faEye;
  }

  // First check if it's a FontAwesome icon name and map it to Lucide
  const mappedIcon = fontAwesomeToLucideMap[iconName];
  if (mappedIcon) {
    return mappedIcon;
  }

  // Then check if it's a Lucide icon name
  const IconComponent = LucideIcons[iconName as keyof typeof LucideIcons];
  if (IconComponent) {
    return IconComponent as React.ComponentType<any>;
  }

  // If not found, return default icon
  return faEye;
};

export const createIconElement = (
  IconComponent: React.ComponentType<any>,
  iconColor = 'white',
): HTMLElement => {
  const container = document.createElement('div');
  container.style.display = 'flex';
  container.style.alignItems = 'center';
  container.style.justifyContent = 'center';

  if (IconComponent) {
    const root = createRoot(container);
    root.render(<IconComponent color={iconColor} />);
  }

  return container;
};
